import permissionsService from "@/features/Company/service/permissions.service";
import { $handleError, $mapToGroupedTree } from "@/utils";
export const PERMISSION = {
  namespaced: true,
  state: {
    entries: [],
    loading: false,
  },
  getters: {
    GET_ENTRIES(state) {
      return state.entries;
    },
    GET_PERMISSION(state) {
      const perms = structuredClone(state.entries);
      perms.sort((a, b) => {
        let fa = a.name.toLowerCase(),
          fb = b.name.toLowerCase();

        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });
      return $mapToGroupedTree(perms);
    },

    GET_LOADING(state) {
      return state.loading;
    },
  },
  mutations: {
    SET_ENTRIES(state, value) {
      state.entries = value;
    },

    SET_LOADING(state, value) {
      state.loading = value;
    },
  },
  actions: {
    GET({ commit }) {
      commit("SET_LOADING", true);
      permissionsService
        .getPermissions()
        .then((res) => {
          commit("SET_ENTRIES", res.data);
        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    },
  },
};
